import { render, staticRenderFns } from "./SmartLearnRoom.vue?vue&type=template&id=a7524bbc"
import script from "./SmartLearnRoom.vue?vue&type=script&lang=js"
export * from "./SmartLearnRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports